// Ladybird Wishlist — localStorage powered
(function(){
  var KEY='lb_wishlist_v1';
  function get(){ try { return JSON.parse(localStorage.getItem(KEY)||'[]'); } catch(e){ return []; } }
  function set(arr){ localStorage.setItem(KEY, JSON.stringify(arr)); render(); }
  function add(h){ var a=get(); if(a.indexOf(h)<0){ a.push(h); set(a); } }
  function remove(h){ var a=get().filter(function(x){return x!==h;}); set(a); }
  function has(h){ return get().indexOf(h)>=0; }
  function toggle(h){ has(h)?remove(h):add(h); }

  function render(){
    var list=get();
    // update header count
    document.querySelectorAll('[data-wish-count]').forEach(function(el){
      el.textContent = list.length;
      el.style.display = list.length > 0 ? '' : 'none';
    });
    // update each heart
    document.querySelectorAll('[data-wish-toggle]').forEach(function(btn){
      var h=btn.getAttribute('data-wish-toggle');
      btn.classList.toggle('lb-wished', has(h));
      btn.setAttribute('aria-pressed', has(h));
    });
    // render the wishlist page if present
    var wrap=document.getElementById('lbWishPage');
    if(wrap) renderPage(wrap, list);
  }

  function toast(msg){
    var t=document.createElement('div');
    t.className='lb-toast'; t.textContent=msg;
    t.style.cssText='position:fixed;left:50%;bottom:30px;transform:translateX(-50%) translateY(20px);background:#241a20;color:#fff;padding:12px 22px;border-radius:30px;font-size:13px;font-weight:600;z-index:9999;opacity:0;transition:all .35s';
    document.body.appendChild(t);
    setTimeout(function(){t.style.opacity='1';t.style.transform='translateX(-50%) translateY(0)';},10);
    setTimeout(function(){t.style.opacity='0';t.style.transform='translateX(-50%) translateY(20px)';setTimeout(function(){t.remove();},400);},2200);
  }

  function renderPage(wrap, list){
    if(list.length===0){
      wrap.innerHTML='<div class="lb-wp-empty"><h2>Your wishlist is empty</h2><p>Save your favourite styles to come back to them later.</p><a href="/collections" class="lb-wp-cta">Browse the Collection →</a></div>';
      return;
    }
    wrap.innerHTML='<div class="lb-wp-grid" id="lbWpGrid"><div style="grid-column:1/-1;text-align:center;padding:40px;color:#8a7f86">Loading your wishlist…</div></div>';
    var grid=document.getElementById('lbWpGrid');
    Promise.all(list.map(function(h){
      return fetch('/products/'+h+'.js').then(function(r){ if(!r.ok) return null; return r.json(); }).catch(function(){return null;});
    })).then(function(prods){
      grid.innerHTML='';
      prods.forEach(function(p,i){
        if(!p){
          var miss=document.createElement('div');
          miss.className='lb-wp-card lb-wp-miss';
          miss.innerHTML='<div style="padding:18px;color:#8a7f86;font-size:13px">This product is no longer available <button class="lb-wp-rm-btn" data-wish-h="'+list[i]+'">Remove</button></div>';
          grid.appendChild(miss);
          return;
        }
        var v = p.variants[0];
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var card=document.createElement('div');
        card.className='lb-wp-card';
        var compareAt = v.compare_at_price && v.compare_at_price > v.price ? '<span class="lb-wp-was">₹'+(v.compare_at_price/100).toFixed(0)+'</span>' : '';
        card.innerHTML =
          '<a href="/products/'+p.handle+'" class="lb-wp-img"><img src="'+img+'" alt="'+(p.title||'')+'"></a>'+
          '<button class="lb-wp-rm" data-wish-h="'+p.handle+'" aria-label="Remove">&times;</button>'+
          '<div class="lb-wp-info">'+
            '<div class="lb-wp-b">Ladybird</div>'+
            '<a href="/products/'+p.handle+'" class="lb-wp-n">'+p.title+'</a>'+
            '<div class="lb-wp-p"><span class="lb-wp-now">₹'+(v.price/100).toFixed(0)+'</span>'+compareAt+'</div>'+
            (p.variants.length === 1 ?
              '<button class="lb-wp-add" data-add-vid="'+v.id+'">Add to Bag</button>' :
              '<a class="lb-wp-add" href="/products/'+p.handle+'">Select Size</a>')+
          '</div>';
        grid.appendChild(card);
      });
      // wire remove buttons
      grid.querySelectorAll('.lb-wp-rm, .lb-wp-rm-btn').forEach(function(b){
        b.addEventListener('click', function(){ remove(this.getAttribute('data-wish-h')); toast('Removed from wishlist'); });
      });
      // wire add to bag
      grid.querySelectorAll('.lb-wp-add[data-add-vid]').forEach(function(b){
        b.addEventListener('click', function(){
          var btn = this; var vid = parseInt(btn.getAttribute('data-add-vid'),10);
          btn.disabled=true; var orig=btn.textContent; btn.textContent='Adding…';
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:vid,quantity:1}),credentials:'same-origin'})
            .then(function(r){if(!r.ok)throw r;return r.json();})
            .then(function(){btn.textContent='Added ✓';return fetch('/cart.js',{credentials:'same-origin'});})
            .then(function(r){return r.json();})
            .then(function(cart){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=cart.item_count;}); toast('Added to bag');setTimeout(function(){btn.disabled=false;btn.textContent=orig;},1500);})
            .catch(function(){btn.disabled=false;btn.textContent=orig;toast('Could not add — try again');});
        });
      });
    });
  }

  // Delegate clicks on heart buttons across the site
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-wish-toggle]');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var h = btn.getAttribute('data-wish-toggle');
    var was = has(h);
    toggle(h);
    toast(was ? 'Removed from wishlist' : 'Saved to wishlist ❤');
  });

  // expose globals
  window.LBWish = { get:get, set:set, add:add, remove:remove, has:has, toggle:toggle };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
